import React, { useState, useEffect } from 'react'
import { message } from 'antd'
import classNames from 'classnames'
import AuditLevelsSelect from 'meinian-package/src/component/auditLevelsSelect'
import { teamHasAuth } from 'meinian-package/src/utils/auth'
import TagList from 'meinian-package/src/component/addInspirationModal/tagList'
import DeleteColl from 'meinian-package/src/component/deleteColl'
import ModalConfirm from 'meinian-package/src/component/modal/modalConfirm'
import Modal from 'meinian-package/src/baseComponent/modal'
import Upload from 'meinian-package/src/component/upload/image'
import Input from 'meinian-package/src/baseComponent/input'
import Icon from 'meinian-package/src/component/icon'
import Cooperation from 'meinian-package/src/component/createIdeaMass/cooperation'
import InspirationType from 'meinian-package/src/component/createIdeaMass/inspirationType'
import noPermissionPrompt from 'meinian-package/src/component/useFunModal/noPermissionPrompt'
import request from 'meinian-package/src/utils/request'
import { ossImg } from 'meinian-package/src/utils/image'
import { Dropdown, Loading } from 'meinian-package/src/baseComponent'
import { IDEA_MASS_ROLE } from 'meinian-package/src/component/enum'
import { flushSync } from 'react-dom'
import { getUserInfo } from 'meinian-package/src/common/userInfo'
import './index.less'

const MAX_UPLODA_SIZE = 10// m

const modeList = [
  { label: '灵感集详情', value: 1 },
  { label: '协作成员', value: 2 },
]
export default (props) => {
  const userInfo = getUserInfo()
  const { children, onClick, style, className, inspirationId, onChange, onDelete, currentRole, auth = [] } = props
  const [visible, setVisible] = useState(false)
  const [ideaMass, setIdeaMass] = useState({})
  const [initIdeaMass, setInitIdeaMass] = useState({})
  const [users, setUsers] = useState([])
  const [whaleUserName, setWhaleUserName] = useState()
  const [whaleUsers, setWhaleUsers] = useState([])
  const [whaleUsersVisible, setWhaleUsersVisible] = useState(false)
  const [loading, setLoading] = useState(true)
  const [mode, setMode] = useState(1)

  useEffect(() => {
    if (visible) {
      inspirationId && fetchIdeaMass()
      setMode(props?.mode || 1)
    } else {
      setIdeaMass({})
      setWhaleUserName()
      setUsers([])
      setWhaleUsers([])
      setWhaleUsersVisible(false)
      setMode(1)
    }
  }, [visible])

  useEffect(() => {
    if (visible) {
      fetchWhaleUsers()
    }
  }, [whaleUserName])

  const onClickTrigger = (e) => {
    e && e.stopPropagation()
    setVisible(true)
    onClick && onClick()
  }

  const fetchIdeaMass = async () => {
    setLoading(true)
    try {
      const res = await request.get('/zhikuan/ins/inspiration/get-inspiration-info', { params: { inspirationId } })
      setIdeaMass({ ...res, ...res.creator, tagList: res.tagList?.map(item => ({ ...item, tagId: item.id })) })
      setInitIdeaMass({ ...res, ...res.creator })
      setUsers([])
    } catch (err) {
      console.error('get-inspiration-info', err)
    }
    setLoading(false)
  }

  const fetchWhaleUsers = async () => {
    if (!userInfo?.isWhalePick) return
    try {
      const res = await request.sget('/zhikuan/whale-api/inspiration/all-user-list', { userName: whaleUserName }, 'fetchWhaleUsers')
      setWhaleUsers(res)
    } catch (err) {
      console.error('all-user-list', err)
    }
  }

  const sendUsers = async (_inspirationId, _users) => {
    try {
      await request.post('/zhikuan/ins/inspiration/auth/update-inspiration-user', { inspirationId: _inspirationId, users: _users })
    } catch (err) {
      console.error('update-inspiration-user', err)
    }
  }

  const edit = async () => {
    const cooperation = users.filter(item => item.role !== 0)
    const markerNum = users.filter(item => item.role === 2)?.length
    if (inspirationId && users.length > 0) {
      const paramsUsers = users.filter(item => item.role !== IDEA_MASS_ROLE.UNSET).map(i => { return { role: i.role, userId: i.userId } })
      sendUsers(inspirationId, paramsUsers)
    }
    try {
      const res = await request.post('/zhikuan/ins/inspiration/modify-inspiration-info', {
        ...ideaMass,
        tagList: undefined,
        tagNameList: ideaMass.tagList?.filter(f => !f.tagId)?.map(item => item.tagName),
        tagIdList: ideaMass.tagList?.filter(f => f.tagId)?.map(item => item.tagId),
      })
      // 返回创建成功的id
      onChange?.(
        res,
        {
          ...ideaMass,
          cooperation: cooperation?.length > 1 ? 1 : 0,
          userNum: cooperation?.length,
          markerNum,
          id: res
        }
      )
      res && setVisible(false)
    } catch (err) {
      console.error('modify-inspiration-info', err)
    }
  }

  const onSubmit = () => {
    if (!ideaMass.name?.trim()) {
      message.error('灵感集的名称不能为空哦')
      return false
    }
    const reg = /(^(ht|f)tps?:)\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/g
    if ((ideaMass.relatedInspiration && !ideaMass.relatedInspiration.match(reg)) || (ideaMass.relatedShop && !ideaMass.relatedShop.match(reg))) {
      message.error('请输入正确的网址')
      return false
    }
    edit()
  }

  const onDeleteIns = () => {
    onDelete?.(ideaMass)
    setVisible(false)
  }

  const onAddTag = (tag) => {
    if (!ideaMass.tagList) { ideaMass.tagList = [] }
    !ideaMass.tagList.find(f => f.tagId === tag.tagId) && ideaMass.tagList.push(tag)
    setIdeaMass(pre => ({ ...pre }))
  }

  const onDeleteTag = (tag) => {
    setIdeaMass(pre => ({ ...pre, tagList: pre.tagList.filter(m => m.tagName !== tag.tagName) }))
  }

  return <>
    <span onClick={onClickTrigger} style={style} className={className}>{children || '编辑灵感集'}</span>
    {visible ? <Modal
      title={<div className="mn-edit-idea-mass-modal-title">编辑灵感集</div>}
      className="mn-edit-idea-mass-modal"
      visible={visible}
      onVisibleChange={_visible => {
        setVisible(_visible)
      }}
      style={{ width: 640, }}
      onOk={() => onSubmit()}
      onCancel={() => setVisible(false)}
    >
      <Loading spinning={loading}>
        <div className="mn-edit-idea-mass-modal-content">
          <div className="mn-edit-idea-mass-modal-header">
            {modeList.map(v => (<div
              key={v.value}
              className={classNames('header-item', { active: mode === v.value })}
              onClick={() => setMode(v.value)}
            >{v.label}</div>))}
          </div>
          {mode === 1 ? <div className="content">
            <div className="item-name">封面</div>
            <Upload
              disabled={!auth.includes('F03')}
              onSuccess={(results) => {
                results?.[0] && setIdeaMass(pre => ({ ...pre, coverImgUrl: results[0].url }))
              }}
              maxSize={MAX_UPLODA_SIZE}
            >
              <a className="cover" style={{ cursor: !auth.includes('F03') ? 'not-allowed' : 'pointer' }}>
                {ideaMass.coverImgUrl || ideaMass.lastBlogList?.length > 0 ? <div className="re-upload" style={{ backgroundImage: `linear-gradient(to right, rgba(0,0,0,0.4) 0%,rgba(0,0,0,0.4) 100%),url(${ossImg(ideaMass.coverImgUrl || ideaMass.lastBlogList[0].mainUrl, 300)})` }}>
                  <Icon type="m-shangchuan" />
                  <span style={{ marginLeft: '2px' }}>重新上传</span>
                </div> : <>
                  <Icon type="m-tianjia" className="upload-icon" />
                  <div className="upload-tip">仅支持JPG、PNG格式，<br />每张不超过{MAX_UPLODA_SIZE}M</div>
                </>}
              </a>
            </Upload>
            <div className="item-name required">名称</div>
            <Input
              wrapClassName="item-input"
              maxLength={20}
              disabled={!auth.includes('F03')}
              value={ideaMass.name}
              placeholder="请输入灵感集名称，不超过20个字"
              onChange={(e) => { const name = e.target.value; setIdeaMass(pre => ({ ...pre, name })) }}
              suffix={`${ideaMass?.name?.length || 0}/20`}
            />
            <div className="item-name">简介</div>
            <Input
              wrapClassName="item-input"
              disabled={!auth.includes('F03')}
              maxLength={50}
              value={ideaMass.introduction}
              placeholder="请输入简介，不超过50个字"
              onChange={(e) => { const introduction = e.target.value; setIdeaMass(pre => ({ ...pre, introduction })) }}
              suffix={`${ideaMass?.introduction?.length || 0}/50`}
            />
            {
            teamHasAuth('meinian_mark_times') && <>
              <div className="item-name">审核层级</div>
              <AuditLevelsSelect
                className="mn-create-idea-mass-select"
                value={ideaMass.needMarkTimes}
                disabled
                onChange={(val) => { setIdeaMass(pre => ({ ...pre, needMarkTimes: val })) }}
              />
            </>
          }
            <div className="item-name">灵感集类型</div>
            <InspirationType
              value={ideaMass.isPro}
              onChange={val => {
                let _value = val
                flushSync(() => setIdeaMass(pre => ({ ...pre, isPro: _value })))
                if (initIdeaMass.isPro === 1 && val === 0 && ideaMass.isPro !== val) {
                  message.info('灵感集PRO无法降级为灵感集，建议新建灵感集')
                  _value = 1
                }
                if (teamHasAuth('meinian_inspiration_pro')) {
                  if (initIdeaMass.isPro === 0 && val === 1 && ideaMass.isPro !== val) {
                    ModalConfirm.show({ title: '确认升级灵感集PRO？',
                      content: '是否将当前灵感集升级为灵感集PRO',
                      onOk: () => setIdeaMass(pre => ({ ...pre, isPro: val })),
                      wrapStyle: { zIndex: '1001' } })
                    _value = 0
                  }
                  setIdeaMass(pre => ({ ...pre, isPro: _value }))
                } else {
                  noPermissionPrompt({})
                }
              }}
            />
            <div className="item-name">标签</div>
            <TagList disabled={!auth.includes('F03')} className="item-tags" onAdd={onAddTag} onDelete={onDeleteTag} value={ideaMass.tagList} />
            <div className="item-name">相关店铺</div>
            <Input
              wrapClassName="item-input"
              maxLength={200}
              disabled={!auth.includes('F03')}
              value={ideaMass.relatedShop}
              placeholder="与该灵感集相关的店铺链接，最多可输入200字"
              onChange={(e) => { const relatedShop = e.target.value; setIdeaMass(pre => ({ ...pre, relatedShop })) }}
              suffix={`${ideaMass?.relatedShop?.length || 0}/200`}
            />
            <div className="item-name">相关灵感集</div>
            <Input
              wrapClassName="item-input"
              maxLength={200}
              disabled={!auth.includes('F03')}
              value={ideaMass.relatedInspiration}
              placeholder="与该灵感集相关的灵感集链接，最多可输入200字"
              onChange={(e) => { const relatedInspiration = e.target.value; setIdeaMass(pre => ({ ...pre, relatedInspiration })) }}
              suffix={`${ideaMass?.relatedInspiration?.length || 0}/200`}
            />
            {userInfo?.isWhalePick ? <>
              <div className="item-name">鲸选客户</div>
              <Dropdown
                overlay={<div className="whale-users-wrapper">
                  <Input placeholder="搜索客户" wrapClassName="search" value={whaleUserName} onChange={e => setWhaleUserName(e.target.value)} />
                  <div className="list custom-scroll-bar">
                    {whaleUsers.map(user => <div
                      key={user.userId}
                      className={classNames('item', { active: user.userId === ideaMass.whaleUserIdList?.[0] })}
                      onClick={() => {
                        if (ideaMass.whaleUserIdList?.[0] === user.userId) {
                          setIdeaMass(pre => ({ ...pre, whaleUserIdList: undefined }))
                        } else {
                          setIdeaMass(pre => ({ ...pre, whaleUserIdList: [user.userId] }))
                          setWhaleUsersVisible(false)
                        }
                      }}
                    >{user.name}</div>)}
                  </div>
                </div>}
                trigger="click"
                visible={whaleUsersVisible}
                onVisibleChange={_whaleUsersVisible => { setWhaleUsersVisible(_whaleUsersVisible) }}
                getPopupContainer={() => document.querySelector('.whale-user')}
              >
                <div className={classNames('whale-user', { focus: whaleUsersVisible })}>
                  <span>{whaleUsers.find(m => m.userId === ideaMass.whaleUserIdList?.[0])?.name || '请选择客户'}</span>
                  <Icon type={whaleUsersVisible ? 'm-Vxing_shang' : 'm-Vxing_xia'} /></div>
              </Dropdown>
            </> : null}
          </div> : null}
          {(ideaMass.id && mode === 2) ? <Cooperation
            style={{ paddingTop: 16, height: '100%', paddingBottom: '24px' }}
            id={ideaMass.id}
            currentRole={currentRole || ideaMass.loginUserInfo?.role}
            onChange={_users => setUsers(_users)}
            users={users}
            setLoading={setLoading}
            defaultHidden={props.mode === 2} // 默认展示
          /> : null}
        </div>
      </Loading>
      {!loading && !ideaMass.isDefault && ideaMass.loginUserInfo?.role === IDEA_MASS_ROLE.OWNER
        ? <a onClick={() => DeleteColl({ params: { inspirationId: ideaMass.id }, onDelete: () => onDeleteIns() })} className="delete">删除灵感集</a>
        : null}
    </Modal>
      : null}
  </>
}
